import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgFilterComponent} from '../../../misc/exg-filter/exg-filter.component';
import {ExgFilterChipsComponent} from '../../../misc/exg-filter-chips/exg-filter-chips.component';
import {ExcRestService} from 'exc-rest-v2';
import {ApplicationService} from '../../../services/application.service';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgApplicationEventEmitter} from '../../../misc/classes/ExgApplicationEventEmitter';
import {ExgEventArgs} from '../../../misc/classes/ExgEventArgs';
import {EnumerationService} from '../../../services/enumeration.service';
import {ExgModalService, ExgOverlayService} from 'exc-controls-v2';
import {DataService} from '../../../services/data.service';
import {ITaskSummaryData} from 'src/app/misc/interfaces/ITaskSummaryData';
import {ICaseSummaryData} from '../../../misc/interfaces/ICaseSummaryData';

@Component({
  selector: 'app-file-overview',
  templateUrl: './file-overview.component.html',
  styles: [
  ]
})
export class FileOverviewComponent extends ExcTranslation implements OnInit {
  /****************************/
  @ViewChild('VCdocumentTableFilterControl', {read: ExgFilterComponent})
  VCdocumentTableFilterControl!: ExgFilterComponent;
  @ViewChild('VCdocumentTableSortControl', {read: ExgFilterComponent})
  VCdocumentTableSortControl!: ExgFilterComponent;
  @ViewChild('VCdocumentTableSearchControl', {read: ExgFilterComponent})
  VCdocumentTableSearchControl!: ExgFilterComponent;
  @ViewChild(ExgFilterChipsComponent) VCFilterChips!: ExgFilterChipsComponent;
  /****************************/
  @Input()
  set data(value: any) {
    if (value) {
      this._data = value;
    }
  }
  get data(): any {
    return this._data;
  }
  private _data: any = {};

  init = true;
  selectedDocs: {[placeholder: string]: any} = {};
  selectedDocsCount = 0;
  allSelected = false;

  acceptedReceiptFileTypes = ['PDF'];

  selectKey = 'vorgID';
  selectedSummary: ITaskSummaryData | ICaseSummaryData | undefined;

  Events = new ExgApplicationEventEmitter();
  /****************************/
  localConfig = {
    attachmentSelection: [] as any[],
    attachmentJagTable: {
      state: 1,
      ready: () => {
        if (!this.selectedSummary?.attachmentJagTable.data || this.selectedSummary?.attachmentJagTable?.isEmpty) {
          this.localConfig.attachmentJagTable.state = 2;
        } else {
          this.localConfig.attachmentJagTable.state = 0;
        }
      },
      search: ($event: string) => {

      }
    },

    showAttachmentPreview: (dokID?: string): void => {
      this.appSvc.Document.Preview.OpenModal({objID: this.selectedSummary?.ID, attID: dokID}, {Events: this.Events});
    },

    showAttachmentUpdateModal: (node: any): void => {
      if ((node.dokCRL === this.excSecurity.UserLogin) || this.userType === 1) {
        if (this.excSecurity.isFeatured('DOCUMENTEDIT')) {
          this.appSvc.Document.Update.OpenModal({dokID: node.dokID}, {Events: this.Events});
        }
      }
    },

    showPDFEditorOverlay: (dokID: string, disabled: boolean): void => {
      if (!disabled) {
        this.modal.show('ModalFilePdfEditorComponent', {
          dokID,
          objID: this.selectedSummary?.ID,
          Events: this.Events,
          selectedSummary: this.selectedSummary
        })

          .subscribe(() => {
          });
      }
    },

    openReport: (rowID: any): void => {
      this.appSvc.Report.Open(rowID, {Events: this.Events});
    },

    deleteAttachment: (node: any): void => {
      if ((node.dokCRL === this.excSecurity.UserLogin) ||
        this.excSecurity.isFeatured('EISUSR') ||
        this.excSecurity.isFeatured('dLUSR')) {
        this.modal.showSimple(
          this.getRessource('DeleteDocument.Title'),
          this.getRessource('DeleteDocument.Message'),
          true,
          true,
          this.getGlobal('Delete'),
          this.getGlobal('Cancel'),
        ).subscribe((rtVal: boolean) => {
          if (rtVal) {
            this.excRest
              .put(this.excRest.computeUrl('DocumentD', {dokID: node.dokID}), {})
              .subscribe((ret: any) => {
                if (ret) {
                  this.modal
                    .showToast(
                      ret.success ? `${this.getRessource('DeleteDocument.success')}` : this.getRessource('DeleteDocument.fail')
                      , `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`
                      , ret.success ? 'fa-duotone fa-trash-can-check' : 'fa-regular fa-times-circle');
                  this.selectedSummary?.LoadSummary();
                }
              });
          }
        });
      }
    },
    addAttachmentToReceipts: (node: any): void => {
      if (this.excSecurity.isFeatured('RECEIPTCREATE') && this.isValidReceipt(node.dokName)) {
        if (this.selectKey === 'auID') {
          this.modal.show('ModalSelectTaskComponent', {entityID: this.data.auID}, true)
            .subscribe((retValue: any) => {
              if (retValue && retValue.length > 0) {
                this.excRest
                  .postBasic(
                    this.excRest.computeUrl(
                      'TaskReceiptC_FromDokument'
                      , {vorgId: retValue[0]})
                    , {selectedDocs: [{dokID: node.dokID}]})
                  .subscribe((ret: any) => {
                    if (ret) {
                      this.modal
                        .showToast(ret.success ? `${this.getRessource('AddDocument.success')}` : this.getRessource('AddDocument.fail'), `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`, ret.success ? 'fa-duotone fa-file-invoice-dollar' : 'fa-regular fa-times-circle');
                      this.selectedSummary?.LoadSummary();
                    }
                  });
              }
            });
        } else {
          this.modal
            .showSimple(
              this.getRessource('AddDocument.Title'),
              this.getRessource('AddDocument.Message'),
              true,
              true,
              this.getGlobal('Create'),
              this.getGlobal('Cancel')
            ).subscribe((rtVal: boolean) => {
            if (rtVal) {
              this.excRest
                .postBasic(
                  this.excRest.computeUrl(
                    'TaskReceiptC_FromDokument'
                    , {vorgId: this.data.vorgID})
                  , {selectedDocs: [{dokID: node.dokID}]})
                .subscribe((ret: any) => {
                  if (ret) {
                    this.modal
                      .showToast(ret.success ? `${this.getRessource('AddDocument.success')}` : this.getRessource('AddDocument.fail'), `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`, ret.success ? 'fa-duotone fa-file-invoice-dollar' : 'fa-regular fa-times-circle');
                    this.selectedSummary?.LoadSummary();
                  }
                });
            }
          });
        }
      }
    },

    addAttachmentToStatements: (node: any): void => {
      if (this.excSecurity.isFeatured('STATEMENTCREATE') && this.isValidReceipt(node.dokName)) {
        if (this.selectKey === 'auID') {
          this.modal.show('ModalSelectTaskComponent', {entityID: this.data.auID}, true)
            .subscribe((retValue: any) => {
              if (retValue && retValue.length > 0) {
                this.excRest
                  .postBasic(
                    this.excRest.computeUrl(
                      'TaskReceiptC_FromDokument'
                      , {vorgId: retValue[0]})
                    , {selectedDocs: [{dokID: node.dokID}], rcptStatement: true}
                    , {})
                  .subscribe((ret: any) => {
                    if (ret) {
                      this.modal
                        .showToast(ret.success ? `${this.getRessource('AddDocumentStatement.success')}` : this.getRessource('AddDocumentStatement.fail'), `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`, ret.success ? 'fa-duotone fa-file-invoice-dollar' : 'fa-regular fa-times-circle');
                      this.selectedSummary?.LoadSummary();
                    }
                  });
              }
            });
        } else {
          this.modal
            .showSimple(
              this.getRessource('AddDocumentStatement.Title'),
              this.getRessource('AddDocumentStatement.Message'),
              true,
              true,
              this.getGlobal('Create'),
              this.getGlobal('Cancel')
            ).subscribe((rtVal: boolean) => {
            if (rtVal) {
              this.excRest
                .postBasic(
                  this.excRest.computeUrl(
                    'TaskReceiptC_FromDokument'
                    , {vorgId: this.data.vorgID})
                  , {selectedDocs: [{dokID: node.dokID}], rcptStatement: true}
                  , {})
                .subscribe((ret: any) => {
                  if (ret) {
                    this.modal
                      .showToast(ret.success ? `${this.getRessource('AddDocumentStatement.success')}` : this.getRessource('AddDocumentStatement.fail'), `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`, ret.success ? 'fa-duotone fa-file-invoice-dollar' : 'fa-regular fa-times-circle');
                    this.selectedSummary?.LoadSummary();
                  }
                });
            }
          });
        }
      }
    },

    openQuestionnaire: (row: any): void => {
      const data = { qcnfID: row.dokGroesse, qverID: row.dokID, isTest: false, qverName: row.dokName};
      this.overlayService.close();
      this.appSvc.QuestionnaireVersion.OpenTab(data);
    },

    editQuestionnaireVersion: (row: any): void => {
      const data = { qcnfID: row.dokGroesse, qverID: row.dokID, isEdit: true, qverName: row.dokName, qverDescription: row.dokBeschreibung};
      this.appSvc.QuestionnaireVersion.OpenModal(data, {Events: this.Events});
    },

    exportQuestionnaireReportExcel: (row: any): void => {
      const data = row.dokID;
      this.appSvc.QuestionnaireVersion.ExportExcelReport(data);
    },

    exportQuestionnaireReportPDF: (row: any): void => {
      const data = row.dokID;
      this.appSvc.QuestionnaireVersion.ExportPDFReport(data);
    },
  };
  userType: number | any;
  // multiSelection = false;
  /****************************/

  constructor(
    private dataSvc: DataService,
    public appSvc: ApplicationService,
    public enmSrv: EnumerationService,
    public excSecurity: ExcSecurityService,
    public overlayService: ExgOverlayService,
    private modal: ExgModalService,
    public excRest: ExcRestService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.registerEvents();
    this.userType = Number(this.appSvc.UserAttributes()?.type) || 2;
    if (this.data?.auID) {
      this.selectKey = 'auID';
      this.selectedSummary = this.dataSvc.Case.Summary.Get(this.data.auID, undefined, {Events: this.Events});
    } else if (this.data?.vorgID) {
      this.selectKey = 'vorgID';
      this.selectedSummary = this.dataSvc.Task.Summary.Get(this.data.vorgID, undefined, {Events: this.Events});
    }
  }

  registerEvents(): void {
    this.Events.Task?.Summary?.DataLoaded?.subscribe((evt: ExgEventArgs) => {
      if (evt.success) {
        this.localConfig.attachmentJagTable.ready();
        this.init = false;
      }
    });
    this.Events.Case?.Summary?.DataLoaded?.subscribe((evt: ExgEventArgs) => {
      if (evt.success) {
        this.localConfig.attachmentJagTable.ready();
        this.init = false;
      }
    });
    this.Events.Receipt?.UploadDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.selectedSummary?.LoadSummary();
    });
    this.Events.Document?.UploadDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.selectedSummary?.LoadSummary();
    });
    this.Events.Document?.UpdateDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.selectedSummary?.LoadSummary();
    });
  }

  selection(dokID: any, event: boolean): void {
    // if (!this.multiSelection) {
    //   this.selectedDocs = {};
    // }
    this.selectedDocs[dokID] = event;
    this.selectedDocsCount = 0;
    for (const key of Object.keys(this.selectedDocs)) {
      if (this.selectedDocs[key]) {
        this.selectedDocsCount++;
      }
    }
    this.allSelected = false;
  }

  toggleSelectAll(): void {
    if (this.allSelected) {
      this.deselectAll();
    } else {
      this.selectAll();
    }
  }

  selectAll(): void {
    if (this.selectedSummary?.attachmentJagTable?.jagdata) {
      for (const folder of this.selectedSummary.attachmentJagTable.jagdata) {
        if (folder.dok_enmIdent_DokTyp !== -1) {
          for (const docElement of folder.documents) {
            this.selectedDocs[docElement.dokID] = true;
          }
        }
      }
      this.selectedDocsCount = Object.keys(this.selectedDocs).filter(k => this.selectedDocs[k]).length;
    }
    this.allSelected = true;
  }

  deselectAll(): void {
    this.selectedDocs = {};
    this.selectedDocsCount = 0;
    this.allSelected = false;
  }

  downloadSelection(): void {
    if (this.selectedDocsCount > 0) {
      const dokIDs = [] as any[];
      for (const key of Object.keys(this.selectedDocs)) {
        if (this.selectedDocs[key]) {
          dokIDs.push({dokID: key});
        }
      }

      if (dokIDs.length > 0) {
        this.excRest
          .post(
            this.excRest.computeUrl(
              'DocumentZip'
              , {})
            , {selectedDocs: dokIDs}
            , {export: true})
          .subscribe((ret: any) => {
            if (ret && ret.success) {
              this.modal
                .showToast(
                  this.getRessource('tooltip.startDownload')
                  , 'md-toast bg-green'
                  , ret.success ? 'fad fa-download' : 'fal fa-times-circle');
            }
          });
      }
    }
  }

  mergedReceiptSelection(rcptStatement = false): void {
    if (this.selectedDocsCount > 0) {
      if (
        (rcptStatement && !this.excSecurity.isFeatured('STATEMENTCREATE'))
        ||
        (!rcptStatement && !this.excSecurity.isFeatured('RECEIPTCREATE'))
      ) {
        return;
      }

      if (!this.selectedSummary?.attachmentJagTable?.jagdata) {
        return;
      }

      const dokIDs = [] as any[];
      const selectedDocuments = [] as any[];

      for (const key of Object.keys(this.selectedDocs)) {
        if (this.selectedDocs[key]) {
          // dokIDs.push({dokID: key});
          for (const folder of this.selectedSummary?.attachmentJagTable?.jagdata) {
            for (const doc of folder.documents) {
              if (doc.dokID === key) {
                doc.dokMIME = doc.dokName.slice(doc.dokName.lastIndexOf('.') + 1);
                selectedDocuments.push(doc);
              }
            }
          }
        }
      }

      if (selectedDocuments.length > 0) {
        if (this.selectKey === 'auID') {
          // nicht gewünscht aus dem Auftrag herraus
          return;
          // this.modal.show('ModalSelectTaskComponent', {entityID: this.data.auID}, true)
          //   .subscribe((retValue: any) => {
          //     if (retValue && retValue.length > 0) {
          //       this.excRest
          //         .postBasic(
          //           this.excRest.computeUrl(
          //             'ReceiptC_MergeByDokIDs'
          //             , {})
          //           , {selectedDocs: dokIDs, rcptStatement, rcpt_vorgID: retValue[0]}
          //           , {})
          //         .subscribe((ret: any) => {
          //           if (ret) {
          //             this.modal
          //               .showToast(
          //                 ret.success
          //                   ? this.getGlobal('Created')
          //                   : this.getGlobal('Abbruch')
          //                 , 'md-toast'
          //                 , ret.success ? 'fad fa-cloud-upload-alt' : 'fal fa-times-circle');
          //           }
          //         });
          //     }
          //   });
        } else {
          this.modal.show('ModalFileToReceiptComponent', {
              receipt: {
                rcptStatement,
                rcptStatementReason: this.selectedSummary.taskDetails.data.vorgBeschreibung,
              },
              selectedDocuments
            }, true)
            .subscribe((retValue: any) => {
              if (retValue && retValue.selectedFiles.length > 0) {
                for (const retValueElement of retValue.selectedFiles) {
                  dokIDs.push({dokID: retValueElement.dokID});
                }

                this.excRest
                    .postBasic(
                      this.excRest.computeUrl(
                        'ReceiptC_MergeByDokIDs'
                        , {})
                      , {
                        selectedDocs: dokIDs
                        , rcptStatement
                        , rcpt_vorgID: this.data.vorgID
                        , rcptStatementReason: rcptStatement ? retValue.rcptStatementReason : undefined
                      }
                      , {})
                    .subscribe((ret: any) => {
                      if (ret) {
                        this.modal
                          .showToast(
                            ret.success
                              ? (!rcptStatement ? this.getRessource('MergeDocument.success')
                                                : this.getRessource('MergeDocumentStatement.success'))
                              : (!rcptStatement ? this.getRessource('MergeDocument.fail')
                                                : this.getRessource('MergeDocumentStatement.fail'))
                            , `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`
                            , ret.success ? 'fad fa-cloud-upload-alt' : 'fal fa-times-circle');
                      }
                    });
              }
            });
        }
      }
    }
  }

  deleteSelection(): void {
    if (this.selectedDocsCount > 0) {
      const dokIDs = [] as any[];
      for (const key of Object.keys(this.selectedDocs)) {
        if (this.selectedDocs[key]) {
          dokIDs.push(key);
        }
      }
      let canDelete =
        this.excSecurity.isFeatured('EISUSR') ||
        this.excSecurity.isFeatured('dLUSR');

      if (!canDelete) {
        canDelete = true;
        for (const folder of this.selectedSummary?.attachmentJagTable?.jagdata ?? []) {
          for (const doc of folder.documents) {
            if (dokIDs.includes(doc.dokID) &&
              doc.dokCRL !== this.excSecurity.UserLogin) {
              canDelete = false;
              break;
            }
          }
          if (!canDelete) {
            break;
          }
        }
      }

      if (!canDelete) {
        return;
      }
      this.modal.showSimple(
          this.getRessource('DeleteDocuments.Title'),
          this.getRessource('DeleteDocuments.Message'),
          true,
          true,
          this.getGlobal('Delete'),
          this.getGlobal('Cancel'),
        ).subscribe((rtVal: boolean) => {
          if (rtVal) {
            this.selectedDocs = {};
            this.selectedDocsCount = 0;
            this.allSelected = false;
            for (const dokID of dokIDs) {
              this.excRest
                .put(this.excRest.computeUrl('DocumentD', {dokID}), {})
                .subscribe((ret: any) => {
                  if (ret) {
                    this.modal
                      .showToast(
                        ret.success ? `${this.getRessource('DeleteDocument.success')}` : this.getRessource('DeleteDocument.fail')
                        , `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`
                        , ret.success ? 'fa-duotone fa-trash-can-check' : 'fa-regular fa-times-circle');
                    this.selectedSummary?.LoadSummary();
                  }
                });
          }}
        });
    }
  }

  openCaseModal(clone = false, link = false): void {
    const dokIDs = [] as any[];
    for (const key of Object.keys(this.selectedDocs)) {
      if (this.selectedDocs[key]) {
        dokIDs.push({dokID: key});
      }
    }

    this.modal.show('ModalSelectCaseComponent', {}, true)
      .subscribe((retValue: any) => {
        if (retValue && retValue.length > 0) {
          const dataObject = {
            selectionObjects: [] as any[],
          };

          for (const retValueElement of retValue) {
            for (const dokID of dokIDs) {
              dataObject.selectionObjects.push({
                dokID: dokID.dokID,
                objID: retValueElement
              });
            }
          }

          this.excRest.post(
            this.excRest.computeUrl(link && !clone ? 'DocumentLinkCU' : 'DocumentCloneC', {})
            , dataObject
          ).subscribe((returnValue: any) => {
            if (returnValue && returnValue.success) {
              this.modal.showToast(
                link && !clone ? 'Verlinkung(en) geändert' : 'Dokument(e) kopiert',
                'md-toast',
                link && !clone ? 'far fa-link' : 'far fa-copy');
            }
          });
        }
      });
  }

  openTaskModal(clone = false, link = false): void {
    const dokIDs = [] as any[];
    for (const key of Object.keys(this.selectedDocs)) {
      if (this.selectedDocs[key]) {
        dokIDs.push({dokID: key});
      }
    }

    this.modal.show('ModalSelectTaskComponent', {}, true)
      .subscribe((retValue: any) => {
        if (retValue && retValue.length > 0) {
          const dataObject = {
            selectionObjects: [] as any[],
          };

          for (const retValueElement of retValue) {
            for (const dokID of dokIDs) {
              dataObject.selectionObjects.push({
                dokID: dokID.dokID,
                objID: retValueElement
              });
            }
          }

          this.excRest.post(
            this.excRest.computeUrl(link && !clone ? 'DocumentLinkCU' : 'DocumentCloneC', {})
            , dataObject
          ).subscribe((returnValue: any) => {
            if (returnValue && returnValue.success) {
              this.modal.showToast(
                link && !clone ? 'Verlinkung(en) geändert' : 'Dokument(e) kopiert',
                'md-toast',
                link && !clone ? 'far fa-link' : 'far fa-copy');
            }
          });
        }
      });
  }

  unlinkDocuments(): void {
    if (this.selectedLinkDocs() > 0) {
      const dataObject = {
        selectionObjects: [] as any[],
      };
      for (const key of Object.keys(this.selectedDocs)) {
        if (this.selectedDocs[key]) {
          dataObject.selectionObjects.push({dokID: key});
        }
      }

      this.excRest.delete(
        this.excRest.computeUrl('DocumentUnLinkU', {objID: this.selectedSummary?.ID})
        , dataObject
      ).subscribe((returnValue: any) => {
        if (returnValue && returnValue.success) {
          this.selectedSummary = this.selectedSummary?.Get(this.data[this.selectKey], undefined, {Events: this.Events});
          this.modal.showToast(
            'Verlinkung(en) gelöscht',
            'md-toast',
            'far fa-trash');
        }
      });
    } else {
      this.modal.showToast(
        'Keine Verlinkungen ausgewählt',
        'md-toast',
        'far fa-triangle-exclamation');
    }
  }

  selectedLinkDocs(): number {
    const linkedObjects = [] as any[];
    if (this.selectedSummary?.attachmentJagTable?.jagdata) {
      for (const folder of this.selectedSummary?.attachmentJagTable?.jagdata) {
        for (const docElement of folder.documents) {
          if (docElement.linked && Object.keys(this.selectedDocs).filter((sDoc: any) => sDoc.key === docElement.dokID)) {
            linkedObjects.push({dokID: docElement.dokID});
          }
        }
      }
    }

    return linkedObjects.length;
  }

  isValidReceipt(fileName: string): boolean {
    return this.acceptedReceiptFileTypes.includes(fileName.slice(fileName.lastIndexOf('.') + 1).toUpperCase());
  }
}
